import React from 'react';

import useStyles from './styles';

const CardGradient = () => {
  const classes = useStyles();

  return <div className={classes.gradient} />;
};

export default CardGradient;
